import type { FC, ReactNode } from "react";
import Stack from "@mui/material/Stack";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import Typography from "@mui/material/Typography";
import { useTranslation } from "@privacy/translations";
import { DynamicGrid } from "../dynamicGrid";
import { Drawer } from "./Drawer";

export const DateTimeInfo: FC<{ label: string; datetime: string }> = ({ label, datetime }) => {
  const { formattedDate, formattedTimeElapsed } = DynamicGrid.useFormattedDateTime(datetime);

  return (
    <Stack direction="row" spacing={3}>
      <Typography
        variant="body2"
        sx={{
          width: "50px",
          fontSize: theme => theme.typography.pxToRem(12),
          color: theme => theme.palette.text.secondary,
        }}
      >
        {label}
      </Typography>
      <Typography sx={{ fontSize: theme => theme.typography.pxToRem(12) }}>
        {formattedDate}
        <Box
          component="span"
          sx={{ ml: 1, fontVariantNumeric: "tabular-nums", color: theme => theme.palette.text.tertiary }}
        >
          ({formattedTimeElapsed})
        </Box>
      </Typography>
    </Stack>
  );
};

export const DatesBand: FC<{ createdAt: string; updatedAt: string; action?: ReactNode; children?: ReactNode }> = ({
  createdAt,
  updatedAt,
  action,
  children,
}) => {
  const { t } = useTranslation();

  return (
    <Box>
      <Divider />
      <Stack sx={{ pb: 2, pt: 3, px: Drawer.PADDING_X, gap: 2 }}>
        <Stack direction="row" sx={{ justifyContent: "space-between" }}>
          <Stack spacing={0.5}>
            <DateTimeInfo label={t("RegistrationGrid.CreatedAtHeader")} datetime={createdAt} />
            <DateTimeInfo label={t("RegistrationGrid.UpdatedAtHeader")} datetime={updatedAt} />
          </Stack>
          {action}
        </Stack>
        {children}
      </Stack>
    </Box>
  );
};
